import { hTagMixin } from "@airportlabs/smalt/src/mixins";
import { reset } from "@airportlabs/smalt/src/ThemeProvider/globalStyles/reset";
import DubaiBold from "assets/fonts/Dubai-Bold.ttf";
import DubaiLight from "assets/fonts/Dubai-Light.ttf";
import DubaiMedium from "assets/fonts/Dubai-Medium.ttf";
import DubaiRegular from "assets/fonts/Dubai-Regular.ttf";
import FSAlbertBold from "assets/fonts/FS Albert-Bold.otf";
import FSAlbertBoldItalic from "assets/fonts/FS Albert-BoldItalic.otf";
import FSAlbertExtraBold from "assets/fonts/FS Albert-ExtraBold.otf";
import FSAlbertItalic from "assets/fonts/FS Albert-Italic.otf";
import FSAlbertLight from "assets/fonts/FS Albert-Light.otf";
import FSAlbertLightItalic from "assets/fonts/FS Albert-LightItalic.otf";
import FSAlbertThin from "assets/fonts/FS Albert-Thin.otf";
import FSAlbertThinItalic from "assets/fonts/FS Albert-ThinItalic.otf";
import FSAlbertRegular from "assets/fonts/FS Albert.otf";
import { createGlobalStyle } from "styled-components";
import { normalize } from "styled-normalize";

const GlobalStyles = createGlobalStyle`
    ${normalize};
    ${reset};

    /* DXB and DWC fonts */
    @font-face {
        font-family: 'Dubai';
        src: url(${DubaiRegular}) format('truetype');
        font-weight: normal;
    }
    @font-face {
        font-family: 'Dubai';
        src: url(${DubaiBold}) format('truetype');
        font-weight: bold;
    }
    @font-face {
        font-family: 'Dubai';
        src: url(${DubaiLight}) format('truetype');
        font-weight: 300;
    }
    @font-face {
        font-family: 'Dubai';
        src: url(${DubaiMedium}) format('truetype');
        font-weight: 500;
    }

    /* BRS fonts (the file names contain a space, so the urls are quoted) */
    @font-face {
        font-family: 'FS Albert';
        src: url('${FSAlbertThin}') format('opentype');
        font-weight: 100;
        font-style: normal;
    }
    @font-face {
        font-family: 'FS Albert';
        src: url('${FSAlbertThinItalic}') format('opentype');
        font-weight: 100;
        font-style: italic;
    }
    @font-face {
        font-family: 'FS Albert';
        src: url('${FSAlbertLight}') format('opentype');
        font-weight: 300;
        font-style: normal;
    }
    @font-face {
        font-family: 'FS Albert';
        src: url('${FSAlbertLightItalic}') format('opentype');
        font-weight: 300;
        font-style: italic;
    }
    @font-face {
        font-family: 'FS Albert';
        src: url('${FSAlbertRegular}') format('opentype');
        font-weight: normal;
        font-style: normal;
    }
    @font-face {
        font-family: 'FS Albert';
        src: url('${FSAlbertItalic}') format('opentype');
        font-weight: normal;
        font-style: italic;
    }
    @font-face {
        font-family: 'FS Albert';
        src: url('${FSAlbertBold}') format('opentype');
        font-weight: bold;
        font-style: normal;
    }
    @font-face {
        font-family: 'FS Albert';
        src: url('${FSAlbertBoldItalic}') format('opentype');
        font-weight: bold;
        font-style: italic;
    }
    @font-face {
        font-family: 'FS Albert';
        src: url('${FSAlbertExtraBold}') format('opentype');
        font-weight: 800;
        font-style: normal;
    }


    html {
        box-sizing: border-box;
        min-height: 100%;
        -moz-osx-font-smoothing: grayscale;
        -webkit-font-smoothing: antialiased;
        /* Pocket Flights Specific global styles below */
        &::-webkit-scrollbar {
            display: none;
        }
        -ms-overflow-style: none;
        scrollbar-width: none;

        overscroll-behavior-y: none;
        overscroll-behavior-x: none;
        -webkit-overscroll-behavior-y: none;
        -webkit-overscroll-behavior-x: none;
    }

    body {
         font-family: ${(props) =>
           window._env_.REACT_APP_REALM === "dxb" ||
           window._env_.REACT_APP_REALM === "dwc"
             ? "Dubai"
             : props.theme.fontFamily.base.name};
        font-size: ${(props) => props.theme.fontSizes.base};
        line-height: ${(props) => props.theme.lineHeights.base};
        color: ${(props) => props.theme.colors.text};
        font-weight: ${(props) => props.theme.fontWeights.normal};
        
        /* Pocket Flights Specific global styles below */

        width: 100%;
        height: 100vh;
        margin: 0;
        overscroll-behavior: none;
        background-color: ${(props) => props.theme.colors.backgroundTertiary};
    }

    * {
        &,
        &:before,
        &:after {
            box-sizing: inherit;
        }
    }

    address,
    blockquote,
    p,
    pre,
    dl,
    ol,
    ul,
    figure,
    hr,
    table,
    fieldset {
        margin-bottom: ${(props) => props.theme.spaces.base};
    }

    dd,
    ol,
    ul {
        margin-left: ${(props) => props.theme.spaces.base};
    }

    img {
        max-width: 100%;
        max-height: 100%;
        vertical-align: middle;
    }

    h1 {
        ${hTagMixin("h1")}
    }
    h2 {
        ${hTagMixin("h2")}
    }
    h3 {
        ${hTagMixin("h3")}
    }
    h4 {
        ${hTagMixin("h4")}
    }
    h5 {
        ${hTagMixin("h5")}
    }
    h6 {
        ${hTagMixin("h6")}
    }

    p {
        margin-bottom: ${(props) => props.theme.spaces.base};
    }

    hr {
        display: block;
        width: 100%;
        border: 0;
        border-top: ${(props) => props.theme.border};
        padding: 0;
        margin: ${(props) => props.theme.spaces.base} auto;
    }

    strong,
    b {
        font-weight: ${(props) => props.theme.fontWeights.bold};
    }

    button {
        cursor: pointer;
    }

    .ReactModal__Body--open {
        overflow: hidden;
    }
`;

export default GlobalStyles;
